import { shuffleArrayInPlace } from '@firesim/simkit-core';
import type { FireCell } from '@firesim/simkit-core';
import { TerrainCodes, terrainTypes } from '../terrain-types';

/**
 * Randomly grow gamba in the given coordinates
 * @param cells An array of cells to draw gamba in
 * @param rate An optional value to indicate the rate of eligible cells that grow gamba. 0-1 where 0 means none and 1 is all. Default 0.6
 * @return The updated cells
 **/
function growGamba(cells: FireCell<TerrainCodes>[], rate: number = 0.35): FireCell<TerrainCodes>[] {
	const eligible = cells.filter((cell) => cell.type === TerrainCodes.Grass);
	const count = Math.floor(eligible.length * rate);
	const updated: FireCell<TerrainCodes>[] = [];

	shuffleArrayInPlace(eligible);
	console.log('region', eligible);

	const gambaTerrain = terrainTypes[TerrainCodes.GambaGrass];
	if (!gambaTerrain) {
		throw new Error("GambaGrass terrain not found");
	}

	for(let i = 0; i < count; i++) {
		const target = eligible.pop();
		if (!target) break;

		updated.push(target);
		target.type = TerrainCodes.GambaGrass;
		target.fuelLoad = gambaTerrain.fuelLoad;

		if (gambaTerrain.colour) {
			target.plane?.drawCell(
				target.x,
				target.y,
				gambaTerrain.colour.red,
				gambaTerrain.colour.green,
				gambaTerrain.colour.blue
			);
		}
	}
	return updated;
}

export default growGamba;
